import { getTopUsers } from "../api/topUsers.api";

export async function fetchTopUsers(params) {
	const raw = await getTopUsers(params);
	const payload = raw?.data || raw || {};
	// Accept various shapes
	const list =
		payload.topUsers ||
		payload.top_users ||
		payload.items ||
		(payload.data && (payload.data.topUsers || payload.data.top_users || payload.data.items)) ||
		[];

	const users = (Array.isArray(list) ? list : []).map(u => ({
		userId: u.user_id,
		name: u.name || "",
		email: u.email || "",
		questions: u.questions ?? u.answered ?? 0, // total answered
		points: u.points ?? u.contribution_points ?? 0,
		answers: u.answers ?? 0,
		lastSeen: u.last_seen,
		avatar: u.avatar || "/images/profile.png"
	}));
	return { users, raw };
}


